import { useEffect, useRef } from 'react'
import { reportDeviceTimezone } from '../api/timezone'
import type { Session } from '../model/schema'

// Зона сотрудника в хабе — последняя увиденная зона его устройства, и переставляет
// её SPA: спрашивать человека значит хранить настройку, а она протухает молча —
// люди летают. Сообщает зону именно продукт: в нём сотрудник живёт, а хаб
// административный и заходят туда редко.
//
// Нужна эта проекция тем местам, где экрана нет, — тексту телеграм-алерта и
// письма, которые рендерит сервер. На экране зона момента берётся у устройства
// напрямую и хранимого значения не спрашивает вовсе.
//
// Раз за загрузку и молча: ручка идемпотентна, а ошибка не эскалируется — ни
// тоста, ни блокировки рендера, следующая загрузка догонит. Цена — текст алерта
// узнаёт о перелёте не мгновенно, а к ближайшему открытию продукта.
export function useDeviceTimezoneSync(session: Session | null): void {
  // Заказчик в хабе не сотрудник: переставлять ему нечего.
  const employee = session?.kind === 'employee'
  const sent = useRef(false)

  useEffect(() => {
    if (!employee || sent.current) return
    // Зона берётся у Intl напрямую, а не через `momentZone()`: тот подставляет
    // зону организации, когда движок зону устройства не назвал, — и она уехала бы
    // в хаб под видом устройства. Нет имени — не шлём вовсе.
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!zone) return
    sent.current = true
    void reportDeviceTimezone(zone).catch(() => undefined)
  }, [employee])
}
